import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { FaEdit, FaTimes, FaRedo } from "react-icons/fa";
import Swal from "sweetalert2";
import axios from "axios";
import './clients_expo.css'
import DeletedClientsExpo from "./deleted-clients-expo";
import FormClientExpo from "./FormClientExpo";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function ClientsExpo({ handleMenuClick }) {
  //variables
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [entries, setEntries] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [showDeleted, setShowDeleted] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [currentClient, setCurrentClient] = useState({});

  //funciones
  const filteredData = searchValue
    ? entries.filter((data) =>
        data.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : entries;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const getEntries = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_clients`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setEntries(res.data.data);
      } else {
        Swal.fire("Error", "Hubo un error al obtener los datos", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
    }
  };

  // const createEntries = async () => {
  //   try {
  //     const result = await Swal.fire({
  //       title: "Registrar Cliente",
  //       html:
  //         '<div class="form-grid">' +
  //         '<div class="row">' +
  //         '<div class="col-md-6 col-6">' +
  //         '<div class="form-group">' +
  //         "<label>No. Cliente</label>" +
  //         '<input type="text" id="id_society_kind" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>RFC</label>" +
  //         "<span class='text-danger'> *</span>" +
  //         '<input type="text" id="rfc" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Calle</label>" +
  //         '<input type="text" id="street" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Ciudad</label>" +
  //         '<input type="text" id="city" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Municipio</label>" +
  //         '<input type="text" id="municipality" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>País</label>" +
  //         '<input type="text" id="country" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Cliente Oracle</label>" +
  //         '<input type="text" id="payment_account" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Método de Pago</label>" +
  //         '<select id="payment_method" class="swal2-input" style="width: 90%; margin-bottom: 10px; background-color: white; border-radius: 5px; box-sizing: border-box;">' +
  //         '<option value="" disabled selected>Selecciona...</option>' +
  //         '<option value="cash">Efectivo</option>' +
  //         '<option value="check">Cheques</option>' +
  //         '<option value="transfer">Transferencia</option>' +
  //         '<option value="others">Otros</option>' +
  //         "</select>" +
  //         "</div>" +
  //         "</div>" +
  //         '<div class="col-md-6 col-6">' +
  //         '<div class="form-group">' +
  //         "<label>Nombre</label>" +
  //         "<span class='text-danger'> *</span>" +
  //         '<input type="text" id="name" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Teléfono</label>" +
  //         '<input type="text" id="phone" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Código Postal</label>" +
  //         '<input type="text" id="zip_code" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Estado</label>" +
  //         '<input type="text" id="state" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Colonia</label>" +
  //         '<input type="text" id="colony" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>E-Mail</label>" +
  //         '<input type="text" id="mail" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Condiciones de Pago</label>" +
  //         '<select id="payment_condition" class="swal2-input" style="width: 90%; margin-bottom: 10px; background-color: white; border-radius: 5px; box-sizing: border-box;">' +
  //         '<option value="" disabled selected>Selecciona...</option>' +
  //         '<option value="cash">Contado</option>' +
  //         '<option value="credit">Crédito</option>' +
  //         '<option value="pue">Crédito / PUE</option>' +
  //         "</select>" +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Prefijo cliente 0000</label>" +
  //         '<input type="text" id="prefix" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;">' +
  //         "</div>" +
  //         "</div>" +
  //         "</div>" +
  //         "</div>",
  //       showDenyButton: true,
  //       confirmButtonText: "Crear",
  //       denyButtonText: "Cancelar",
  //       padding: "0px",
  //       width: "1100px",
  //       color: "#000",
  //       backdrop: `
  //                 rgba(0,0,0,0.8)
  //             `,
  //       customClass: {
  //         confirmButton: "btn-amc-blue",
  //         denyButton: "btn-cancel",
  //         title: "alert-title",
  //         popup: "alert-bg",
  //       },
  //       preConfirm: function () {
  //         const id_society_kind = document.getElementById("id_society_kind").value;
  //         const name = document.getElementById("name").value;
  //         const rfc = document.getElementById("rfc").value;
  //         const phone = document.getElementById("phone").value;
  //         const street = document.getElementById("street").value;
  //         const zip_code = document.getElementById("zip_code").value;
  //         const city = document.getElementById("city").value;
  //         const state = document.getElementById("state").value;
  //         const municipality = document.getElementById("municipality").value;
  //         const colony = document.getElementById("colony").value;
  //         const country = document.getElementById("country").value;
  //         const mail = document.getElementById("mail").value;
  //         const payment_account = document.getElementById("payment_account").value;
  //         const payment_condition = document.getElementById("payment_condition").value;
  //         const payment_method = document.getElementById("payment_method").value;
  //         const prefix = document.getElementById("prefix").value;

  //         if (!rfc || !name) {
  //           Swal.showValidationMessage("Nombre y RFC son obligatorios");
  //           return false;
  //         }

  //         return {
  //           id_society_kind,
  //           name,
  //           rfc,
  //           phone,
  //           street,
  //           zip_code,
  //           city,
  //           state,
  //           municipality,
  //           colony,
  //           country,
  //           mail,
  //           payment_account,
  //           payment_condition,
  //           payment_method,
  //           prefix,
  //         };
  //       },
  //     });

  //     if (result.isConfirmed) {
  //       const userData = result.value;

  //       const response = await axios.post(
  //         `${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_clients/store`,
  //         userData,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //           },
  //         }
  //       );

  //       Swal.fire(
  //         "¡Creado!",
  //         "El elemento ha sido registrado exitosamente.",
  //         "success"
  //       );
  //       setUpdateTrigger(!updateTrigger);
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire("Cancelado", "Acción cancelada.", "error");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     Swal.fire("Error", "Hubo un error", "error");
  //   }
  // };

  // const updateEntries = async (id) => {
  //   try {
  //     //Obtener los datos de la institucion
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_clients/find/${id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //         },
  //       }
  //     );
  //     const entryData = response.data.data;

  //     console.log(entryData)

  //     const result = await Swal.fire({
  //       title: "Editar Cliente",
  //       html:
  //         '<div class="form-grid">' +
  //         '<div class="row">' +
  //         '<div class="col-md-6 col-6">' +
  //         '<div class="form-group">' +
  //         "<label>No. Cliente</label>" +
  //         `<input type="text" id="id_society_kind" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].id_society_kind || ''}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>RFC</label>" +
  //         "<span class='text-danger'> *</span>" +
  //         `<input type="text" id="rfc" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].rfc}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Calle</label>" +
  //         `<input type="text" id="street" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].street}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Ciudad</label>" +
  //         `<input type="text" id="city" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].city}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Municipio</label>" +
  //         `<input type="text" id="municipality" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].municipality}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>País</label>" +
  //         `<input type="text" id="country" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].country}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Cliente Oracle</label>" +
  //         `<input type="text" id="payment_account" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].payment_account}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Método de pago</label>" +
  //         `<select id="payment_method" class="swal2-input" style="width: 90%; margin-bottom: 10px; background-color: white; border-radius: 5px; box-sizing: border-box;">` +
  //         '<option value="" disabled selected>Selecciona...</option>' +
  //         `<option value="cash" ${entryData[0].payment_method === 'cash' ? 'selected' : ''}>Efectivo</option>` +
  //         `<option value="check" ${entryData[0].payment_method === 'check' ? 'selected' : ''}>Cheques</option>` +
  //         `<option value="transfer" ${entryData[0].payment_method === 'transfer' ? 'selected' : ''}>Transferencia</option>` +
  //         `<option value="others" ${entryData[0].payment_method === 'others' ? 'selected' : ''}>Otros</option>` +
  //         `</select>` +
  //         "</div>" +
  //         "</div>" +
  //         '<div class="col-md-6 col-6">' +
  //         '<div class="form-group">' +
  //         "<label>Nombre</label>" +
  //         "<span class='text-danger'> *</span>" +
  //         `<input type="text" id="name" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].name}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Teléfono</label>" +
  //         `<input type="text" id="phone" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].phone}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Código Postal</label>" +
  //         `<input type="text" id="zip_code" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].zip_code}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Estado</label>" +
  //         `<input type="text" id="state" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].state}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Colonia</label>" +
  //         `<input type="text" id="colony" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].colony}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>E-Mail</label>" +
  //         `<input type="text" id="mail" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].mail}">` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Condiciones de pago</label>" +
  //         `<select id="payment_condition" class="swal2-input" style="width: 90%; margin-bottom: 10px; background-color: white; border-radius: 5px; box-sizing: border-box;">` +
  //         '<option value="" disabled selected>Selecciona...</option>' +
  //         `<option value="cash" ${entryData[0].payment_condition === 'cash' ? 'selected' : ''}>Contado</option>` +
  //         `<option value="credit" ${entryData[0].payment_condition === 'credit' ? 'selected' : ''}>Crédito</option>` +
  //         `<option value="pue" ${entryData[0].payment_condition === 'pue' ? 'selected' : ''}>Crédito / PUE</option>` +
  //         `</select>` +
  //         "</div>" +
  //         '<div class="form-group">' +
  //         "<label>Prefijo cliente 0000</label>" +
  //         `<input type="text" id="prefix" class="swal2-input" style="width: 90%; margin-bottom: 10px; box-sizing: border-box;" value="${entryData[0].prefix}">` +
  //         "</div>" +
  //         "</div>" +
  //         "</div>" +
  //         "</div>",
  //       showDenyButton: true,
  //       confirmButtonText: "Guardar",
  //       denyButtonText: "Cancelar",
  //       padding: "0px",
  //       width: "1000px",
  //       color: "#000",
  //       backdrop: `
  //                 rgba(0,0,0,0.8)
  //             `,
  //       customClass: {
  //         confirmButton: "btn-amc-blue",
  //         denyButton: "btn-cancel",
  //         title: "alert-title",
  //         popup: "alert-bg",
  //       },
  //       preConfirm: function () {
  //         const id_society_kind = document.getElementById("id_society_kind").value;
  //         const name = document.getElementById("name").value;
  //         const rfc = document.getElementById("rfc").value;
  //         const phone = document.getElementById("phone").value;
  //         const street = document.getElementById("street").value;
  //         const zip_code = document.getElementById("zip_code").value;
  //         const city = document.getElementById("city").value;
  //         const state = document.getElementById("state").value;
  //         const municipality = document.getElementById("municipality").value;
  //         const colony = document.getElementById("colony").value;
  //         const country = document.getElementById("country").value;
  //         const mail = document.getElementById("mail").value;
  //         const payment_account = document.getElementById("payment_account").value;
  //         const payment_condition = document.getElementById("payment_condition").value;
  //         const payment_method = document.getElementById("payment_method").value;
  //         const prefix = document.getElementById("prefix").value;

  //         if ( !name || !rfc ) {
  //           Swal.showValidationMessage("Nombre y RFC son obligatorios");
  //           return false;
  //         }

  //         return {
  //           id_society_kind,
  //           name,
  //           rfc,
  //           phone,
  //           street,
  //           zip_code,
  //           city,
  //           state,
  //           municipality,
  //           colony,
  //           country,
  //           mail,
  //           payment_account,
  //           payment_condition,
  //           payment_method,
  //           prefix,
  //         };
  //       },
  //     });

  //     if (result.isConfirmed) {
  //       const updateUserData = result.value;
  //       // Realizar la solicitud POST al servidor para actualizar la institucion
  //       const updateResponse = await axios.post(
  //         `${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_clients/update/${id}`,
  //         updateUserData,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
  //           },
  //         }
  //       );
  //       console.log("Respuesta de actualización:", updateResponse);

  //       Swal.fire(
  //         "¡Actualizado!",
  //         "El elemento ha sido actualizado exitosamente.",
  //         "success"
  //       );
  //       setUpdateTrigger(!updateTrigger);
  //     } else if (result.dismiss === Swal.DismissReason.cancel) {
  //       Swal.fire(
  //         "Cancelado",
  //         "No se ha realizado ninguna actualización.",
  //         "error"
  //       );
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     Swal.fire("Error", "Hubo un error", "error");
  //   }
  // };

  const deleteEntries = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });
      if (result.isConfirmed) {
        await axios.delete(`${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_clients/${id}`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });
        Swal.fire("¡Eliminado!", "El elemento ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const closeModal = () => {
    setStatusModal(false);
  }

  const handleCloseModal = (data, statusClose) => {
    if(statusClose === "no-update") {
      setStatusModal(data);
    } else {
      setUpdateTrigger(!updateTrigger);
      setStatusModal(data);
    }
  }

  const openModal = (currentClient) => {
    setStatusModal(true);
    setCurrentClient(currentClient)
  }

  useEffect(() => {
    getEntries();
  }, [updateTrigger]);

  return (
    <>
      <Helmet>
        <title>Horus | Clientes Expo</title>
      </Helmet>
      <ScrollToTop />
      {statusModal && 
        <div
          className="modal show backgroundmodal"
          style={{ display: 'block', position: 'initial' }}
        >
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Title>
                {currentClient ? (
                  <p>Editar Cliente</p>
                ): (
                  <p>Crear Cliente</p>
                )}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
               <FormClientExpo closeModal={handleCloseModal} currentClient={currentClient} />
            </Modal.Body>
          </Modal.Dialog>
        </div>
      }
      <div className="table-responsive">
        <div className="dataTables_wrapper dt-bootstrap4 no-footer container-fluid" id="datatables_wrapper">

        <div className="text-right mb-2 ">
              <button className="btnn" onClick={() => setShowDeleted(!showDeleted)}>
                  {showDeleted ? "Ver Activos" : "Ver Eliminados"}
              </button>   
          </div>
          {showDeleted ? (
              <DeletedClientsExpo setUpdateTrigger={setUpdateTrigger} updateTrigger={updateTrigger} />
          ) : (
            <>
          <div className="text-right mb-4">
            <button className="btnn" 
            onClick={() => openModal()}>
              Añadir Clientes
            </button>
          </div>
          <div className="row justify-content-between mb-2">
            <div className="col-sm-12 col-md-4">
              <div className="dataTables_length mb-2" id="dataTables_length">
                <label className="d-flex justify-content-start">
                  <span className="mr-2 p-2">Mostrar</span>
                  <select
                    name="datatables_length"
                    aria-controls="datatables_length"
                    className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                    onChange={showEntries}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="ml-2 p-2">registros</span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4">
              <div className="datatables_filter" id="datatables_filter">
                <label className="d-flex justify-content-end">
                  <input
                    type="search"
                    id="searchInput"
                    className="form-control form-control-sm"
                    placeholder="Buscar..."
                    aria-controls="datatables"
                  />
                  <button className="btnn" onClick={handleSearch}>
                    Buscar
                  </button>
                </label>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Nombre
                    </th>

                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      RFC
                    </th>

                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((entry) => (
                    <tr key={entry.id}>
                      <td>{entry.name}</td>
                      <td>{entry.rfc}</td>
                      <td>
                        <FaEdit
                          className="editButton"
                          onClick={() => openModal(entry)}
                        />
                        <FaTimes className='deleteButton' 
                        onClick={() => { deleteEntries(entry.id) }} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          </>
          )}
        </div>
      </div>
    </>
  );
}

export default ClientsExpo;
